import { ENDPOINTS, QUERYKEYS, ENDPOINT_METHODS, createEndpointUrl } from './ApiConstants';
import { useQuery, useMutation } from '@tanstack/react-query';
import { localFetch } from './LocalFetch';
import { createFetchWrapper } from './WebUtils';
// @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
import { useMsal } from '@azure/msal-react';

const DEBUG = true;

const fetchWrapper = createFetchWrapper({
    createEndpointUrl,
    localFetch,
    endpointMethods: ENDPOINT_METHODS
});

// EXAMPLE GET HOOK IMPLEMENTATION
export function useExampleGet({ parameters }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();

    return useQuery({
        queryKey: [
            // QueryKey goes here. See ApiConstants.js for more info.
            QUERYKEYS.exampleGet,
            // Parameters go here.
            {
                parameters
            }],
        // Query function to make the actual query with.
        queryFn: async ({ queryKey }) => {
            if (DEBUG) console.log("Api :: exampleGet");

            const [_key, { parameters }] = queryKey;

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.exampleGet,
                parameters,
                msal
            });

            return { queryKey: _key, result };
        },
        // To disable the query, use this.
        enabled: true,
        // Make sure this option makes sense to your context.
        refetchOnWindowFocus: false,
    });


}

// EXAMPLE POST HOOK IMPLEMENTATION
export function useExamplePost({ onSuccess, onError }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();

    return useMutation({
        mutationFn: async (body) => {
            if (DEBUG) console.log("Api :: examplePost");

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.examplePost,
                body,
                msal
            });

            return { result };
        },
        onSuccess: (result) => {
            if (DEBUG) console.log("MutationExample :: examplePost :: onSuccess")
            if (DEBUG) console.log(result);
            if (onSuccess) onSuccess(result);
        },
        onError: (error) => {
            if (DEBUG) console.log("MutationExample :: examplePost :: onError")
            if (DEBUG) console.log(error);
            if (onError) onError(error);
        }
    });
}

export function useGetConfiguration({ parameters }) {
    // @TEMPLATE_@MSAL - Uncomment this line to use MSAL for authentication.
    const msal = useMsal();

    return useQuery({
        queryKey: [
            // QueryKey goes here. See ApiConstants.js for more info.
            QUERYKEYS.getConfiguration,
            // Parameters go here.
            {
                parameters
            }],
        // Query function to make the actual query with.
        queryFn: async ({ queryKey }) => {
            if (DEBUG) console.log("Api :: useGetConfiguration");

            const [_key, { parameters }] = queryKey;

            const result = await fetchWrapper({
                endpoint: ENDPOINTS.getConfiguration,
                parameters,
                msal
            });

            return { queryKey: _key, result };
        },
        // To disable the query, use this.
        enabled: true,
        // Make sure this option makes sense to your context.
        refetchOnWindowFocus: false,
    });
}